/**
 * CrmConnectTour-specific types and step definitions.
 *
 * The CrmConnectTour walks admins through connecting Agency Zoom
 * to Voley via Zapier — explaining benefits, pricing, and how to
 * find and enter Zapier API credentials from Agency Zoom.
 */

import type { TourStep } from '../types';

/** Unique identifiers for each CrmConnectTour step */
export type CrmConnectTourStepId =
  | 'crm_welcome'
  | 'highlight_az_connect'
  | 'highlight_az_find_creds'
  | 'highlight_az_zap_fields'
  | 'crm_complete';

/** Ordered list of all CrmConnectTour steps */
export const CRM_CONNECT_TOUR_STEPS: TourStep[] = [
  {
    id: 'crm_welcome',
    type: 'modal',
    title: '',
    content: '',
  },
  {
    id: 'highlight_az_connect',
    type: 'highlight',
    targetSelector: '[data-tour-id="az-connect-btn"]',
    title: 'Connect Agency Zoom',
    content:
      'Click the Connect button to start linking your Agency Zoom account with Voley through Zapier.',
    placement: 'left',
    advanceOnElement: '[data-tour-id="az-zapier-section"]',
  },
  {
    id: 'highlight_az_find_creds',
    type: 'highlight',
    targetSelector: '[data-tour-id="az-zapier-section"]',
    title: 'Find Your Zapier Credentials',
    content:
      'In Agency Zoom, go to My Agency \u2192 Integration \u2192 scroll to the bottom and click "Zapier" \u2192 click "Show API Key". Copy the API Key and API Secret, then paste them into the Zap Key and Zap Secret fields here.',
    placement: 'left',
  },
  {
    id: 'highlight_az_zap_fields',
    type: 'highlight',
    targetSelector: '[data-tour-id="az-zap-fields"]',
    title: 'Enter Your Credentials',
    content:
      'Paste your API Key into the Zap Key field and your API Secret into the Zap Secret field, then click "Save Credentials" to continue.',
    placement: 'top',
    advanceOnElementRemoved: '[data-tour-id="az-zap-fields"]',
  },
  {
    id: 'crm_complete',
    type: 'modal',
    title: '',
    content: '',
  },
];
